<template>
  <v-card class="dashboard-card elevation-2 pa-4">
    <!-- TEXTO -->
    <div class="card-content">
      <span class="card-title">{{ situacao }}</span>
      <span class="card-value">{{ count }}</span>
    </div>

    <!-- ÍCONE -->
    <div
      class="icon-container elevation-3"
      :style="gradientStyle"
    >
      <!-- Vuetify 2: ícone como conteúdo -->
      <v-icon :color="iconColor" size="22">
        {{ icon }}
      </v-icon>
    </div>
  </v-card>
</template>

<script>
import { getStatusColor, getStatusGradient } from '@/util/dashboardColors'

export default {
  name: 'DashboardCard',

  props: {
    situacao: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: 'white',
    },
  },

  computed: {
    gradientStyle() {
      const base = getStatusColor(this.situacao)
      return {
        background: getStatusGradient(this.situacao),
        boxShadow: `0 4px 12px ${base}55`,
      }
    },
  },
}
</script>

<style scoped>
.dashboard-card {
  position: relative;
  border-radius: 14px;
  min-height: 110px;
}

/* TEXTO */
.card-content {
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #222;
}

.card-value {
  font-size: 28px;
  font-weight: 400;
  margin-top: 6px;
}

/* ÍCONE */
.icon-container {
  position: absolute;
  right: 16px;
  bottom: 16px;

  width: 42px;
  height: 42px;
  border-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
